// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"740":"328fd336efa45728a628","748":"bffbb46fb283149c3888"}[chunkId] + ".js";
};